import ACTIONS from "./CronSettingsActionTypes";

export const getCronSettingsListRequest = (payload) => ({
  type: ACTIONS.GET_CRON_SETTINGS_LIST_REQUEST,
  payload,
});

export const getCronSettingsListResponse = (payload) => ({
  type: ACTIONS.GET_CRON_SETTINGS_LIST_RESPONSE,
  payload,
});

export const postCronSettingsRequest = (payload) => ({
  type: ACTIONS.POST_CRON_SETTINGS_REQUEST,
  payload,
});

export const postCronSettingsResponse = (payload) => ({
  type: ACTIONS.POST_CRON_SETTINGS_RESPONSE,
  payload,
});

export const postCronSettingsResponseClear = () => ({
  type: ACTIONS.POST_CRON_SETTINGS_RESPONSE_CLEAR,
});

export const putCronSettingsRequest = (payload) => ({
  type: ACTIONS.PUT_CRON_SETTINGS_REQUEST,
  payload,
});

export const putCronSettingsResponse = (payload) => ({
  type: ACTIONS.PUT_CRON_SETTINGS_RESPONSE,
  payload,
});

export const putStatusCronSettingsRequest = (payload) => ({
  type: ACTIONS.PUT_STATUS_CRON_SETTINGS_REQUEST,
  payload,
});

export const putStatusCronSettingsResponse = (payload) => ({
  type: ACTIONS.PUT_STATUS_CRON_SETTINGS_RESPONSE,
  payload,
});

export const deleteCronSettingsRequest = (payload) => ({
  type: ACTIONS.DELETE_CRON_SETTINGS_REQUEST,
  payload,
});

export const deleteCronSettingsResponse = (payload) => ({
  type: ACTIONS.DELETE_CRON_SETTINGS_RESPONSE,
  payload,
});

export const deleteCronSettingsResponseClear = () => ({
  type: ACTIONS.DELETE_CRON_SETTINGS_RESPONSE_CLEAR,
});

//EMAILS LIST

export const getCronReminderEmailsListRequest = (payload) => ({
  type: ACTIONS.GET_CRON_REMINDER_EMAILS_LIST_REQUEST,
  payload,
});

export const getCronReminderEmailsListResponse = (payload) => ({
  type: ACTIONS.GET_CRON_REMINDER_EMAILS_LIST_RESPONSE,
  payload,
});
